<div class="anonymous-language-menu-title-container">
    <span #titleItem class="menu-title-item language-title"> 
        <mat-icon fontSet="phr-iconset" class="phr-iconset-{{icon}} icon phr-iconset"></mat-icon>
        <span>{{text | translate:locale.language}}</span>
    </span>
</div>